export const dashboardModals = {
    serviceStats: () => import('./service-stats-modal'),
    serviceInvitation: () => import('./service-invitation-modal'),
    serviceWithdrawal: () => import('./service-withdrawal-modal'),
    serviceTransactions: () => import('./service-transactions-modal'),
    top: () => import('./top-modal'),
};
